<app-loader [hidden]="!showLoader"></app-loader>
<app-section>
  <app-back-navigation-btn [routeUrl]="DASHBOARD_URL"></app-back-navigation-btn>
</app-section>
<app-component-seperator></app-component-seperator>
<app-section>
  <app-page-header *ngIf="header" [title]="header.depositName" [subTitle]="header.reportingName">
  </app-page-header>
</app-section>
<app-component-seperator></app-component-seperator>
<app-section>
  <div class="tab-section">
    <app-alert [alert]="alert"></app-alert>
    <div *ngIf="!isReportingCycleLocked">
      <form [formGroup]="printerProofForm" *ngIf="printerProofForm && isAdmin && header.workflowStatus != '7'">
        <app-form-header [title]="'Printer Proof'"></app-form-header>
        <div class="printerProofUpload">
          <app-input-file [labelName]="'Upload printer proof'" [submitted]="submittedPrinterProofForm"
            [inputFormControl]="printerProofForm?.controls?.file" (onFileSelect)="selectFile($event)" id="file">
          </app-input-file>
        </div>
        <div class="description">
          <app-input-textbox [labelName]="'Description'" [submitted]="submittedPrinterProofForm"
            [inputFormControl]="printerProofForm?.controls?.description">
          </app-input-textbox>
        </div>
        <div class="upload-button-style">
          <app-button
            (btnClick)="submitPrinterProofForm()"
            [type]="'primary'"
            [name]="'upload document'"
            [disable]="header.workflowStatus !== '8'"
          ></app-button>
        </div>
      </form>
    </div>
    <app-form-header [title]="'Uploaded printer proof'"></app-form-header>
    <div class="usesrs-details">
      <app-workflow-table-grid [showrecord]="true" [headers]="PrinterProofHeaders" [data]="printerProofData"
        [noRecordTxt]="'No document record found.'" (onDelete)="onFileUploadDataDelete($event)"
        (onDownload)="downloadFile($event)" (onLink)="downloadFile($event)"></app-workflow-table-grid>
    </div>
    <div class="footer-btns" *ngIf="printerProofData && printerProofData.length">
      <div *ngIf="isAdmin">
        <div style="display: flex;" *ngIf="printerProofData[0].workflowStatus == '8'">
          <app-button *ngIf="comments && comments.length" (btnClick)="viewComments()" [type]="'primary'" [name]="'View comments'"></app-button>
          <app-button (btnClick)="submitPrinterProof()" [disable]="isReportingCycleLocked" [type]="'primary'" [name]="'Submit printer proof'"></app-button>
        </div>
        <div style="display: flex;" *ngIf="printerProofData[0].workflowStatus !== '8'">
          <app-button *ngIf="comments && comments.length" (btnClick)="viewComments()" [type]="'primary'" [name]="'View comments'"></app-button>
          <app-button (btnClick)="BacktoManageWorkflow()" [textTransformNone]="true" [type]="'secondary'"
            [name]="BACK_TO_REPORTING_WORKFLOW"></app-button>
          <app-button (btnClick)="viewConsents()" [textTransformNone]="true" [type]="'secondary'"
            [name]="'View Consent'"></app-button>
        </div>
      </div>
      <div *ngIf="isEndorser">
        <div style="display: flex;" *ngIf="printerProofData[0].workflowStatus !== '5'">
          <app-button *ngIf="comments && comments.length" (btnClick)="viewComments()" [type]="'primary'" [name]="'View comments'"></app-button>
          <app-button (btnClick)="BacktoManageWorkflow()" [textTransformNone]="true" [type]="'secondary'"
            [name]="BACK_TO_REPORTING_WORKFLOW"></app-button>
          <app-button (btnClick)="viewConsents()" [textTransformNone]="true" [type]="'secondary'"
            [name]="'View Consent'"></app-button>
        </div>
        <div *ngIf="printerProofData[0].workflowStatus === '5'">
          <div>

            <app-input-checkbox  [inputFormControl]="acknowledgeCheckbox"
              [labelName]="'I acknowledge that I have read and verified the printer proofs.'"></app-input-checkbox>
          </div>
          <div style="display: flex;">
            <app-button (btnClick)="submitAcknowledgement()" [disable]="isReportingCycleLocked || !acknowledgeCheckbox.value" [type]="'success'"
              [name]="'Submit acknowledgement'"></app-button>
            <app-button (btnClick)="rejectedByEndorser()" [disable]="isReportingCycleLocked" [type]="'cancel'" [name]="'Reject'"></app-button>
          </div>
        </div>
      </div>
      <div *ngIf="isCPQP">
        <div style="display: flex;" *ngIf="printerProofData && (printerProofData[0].workflowStatus !== '1' || !isNonConsentedCP)">
          <app-button *ngIf="comments && comments.length" (btnClick)="viewComments()" [type]="'primary'" [name]="'View comments'"></app-button>
          <app-button (btnClick)="BacktoManageWorkflow()" [textTransformNone]="true" [type]="'secondary'"
            [name]="BACK_TO_REPORTING_WORKFLOW"></app-button>
            <app-button (btnClick)="viewConsents()" [textTransformNone]="true" [type]="'secondary'"
            [name]="'View Consent'"></app-button>
        </div>
        <div *ngIf="printerProofData && printerProofData[0].workflowStatus === '1' && isNonConsentedCP">
          <div>
            <app-input-checkbox [inputFormControl]="acknowledgeCheckbox"
              [labelName]="'I acknowledge that I have read and verified the printer proofs.'"></app-input-checkbox>
          </div>
          <div style="display: flex;">
            <app-button (btnClick)="ConsentToPublish()" [disable]="isReportingCycleLocked || !acknowledgeCheckbox.value" [type]="'success'"
              [name]="'Consent to publish'"></app-button>
            <app-button (btnClick)="rejectedByCPQP()" [disable]="isReportingCycleLocked" [type]="'cancel'" [name]="'Reject'"></app-button>
          </div>
        </div>
      </div>
      <div *ngIf="isConsumer">
        <div style="display: flex;">
          <app-button *ngIf="comments && comments.length" (btnClick)="viewComments()" [type]="'primary'" [name]="'View comments'"></app-button>
          <app-button (btnClick)="BacktoManageWorkflow()" [textTransformNone]="true" [type]="'secondary'"
            [name]="BACK_TO_REPORTING_WORKFLOW"></app-button>
          <app-button (btnClick)="viewConsents()" [textTransformNone]="true" [type]="'secondary'"
            [name]="'View Consent'"></app-button>
        </div>
      </div>
    </div>

    <div *ngIf="alerts">
      <app-alert *ngFor="let alert of alerts" [alert]="alert"></app-alert>
    </div>
  </div>
</app-section>

<div>

</div>


<app-pop-up *ngIf="showSubmittedPrinterProofPopUp">
  <app-pop-up-header [showSuccessIcon]="true" [headerName]="'Submission successful'"
    (close)="showSubmittedPrinterProofPopUp = !showSubmittedPrinterProofPopUp"></app-pop-up-header>

  <div class="comment">
    <span class="field-name">Your printer proof has been sent for review.</span>
  </div>

  <app-pop-up-footer>
    <app-button [name]="'Go to workflows'" [type]="'primary'" (btnClick)="BacktoManageWorkflow()"></app-button>
  </app-pop-up-footer>
</app-pop-up>

<app-delete-confirmation-popup *ngIf="showDeletePopup" [message]="popupMessage" (onCancel)="closeDeletePopup()"
  (onDelete)="onDeleteUploadedDocument()"></app-delete-confirmation-popup>

<app-pop-up *ngIf="showRejectedPopup">
  <app-pop-up-header [headerName]="'Reason for Rejection'" (close)="closeRejectionPopup()">
  </app-pop-up-header>
  <div class="comment" *ngIf="commentControl">
    <app-input-textarea [labelName]="'Please specify your reason for rejection'" [submitted]="submitCommentForm"
      [inputFormControl]="commentControl">
    </app-input-textarea>
  </div>
  <app-pop-up-footer>
    <app-button [name]="'Cancel'" [type]="'outlined'" (btnClick)="closeRejectionPopup()"></app-button>
    <app-button [name]="'Send'" [type]="'primary'" (btnClick)="confirmRejection()"></app-button>
  </app-pop-up-footer>
</app-pop-up>

<app-pop-up *ngIf="showCpQpRejectedPopup">
  <app-pop-up-header [headerName]="'Reason for Rejection'" (close)="closeCpQpRejectionPopup()">
  </app-pop-up-header>
  <div class="comment" *ngIf="commentControl">
    <app-input-textarea [labelName]="'Please specify your reason for rejection'" [submitted]="submitCommentForm"
      [inputFormControl]="commentControl">
    </app-input-textarea>
  </div>
  <app-pop-up-footer>
    <app-button [name]="'Cancel'" [type]="'outlined'" (btnClick)="closeCpQpRejectionPopup()"></app-button>
    <app-button [name]="'Send'" [type]="'primary'" (btnClick)="confirmCpQpRejection()"></app-button>
  </app-pop-up-footer>
</app-pop-up>

<app-pop-up *ngIf="showApprovedPopup">
  <app-pop-up-header [showSuccessIcon]="true" [headerName]="'Submitted'"
    (close)="showApprovedPopup = !showApprovedPopup"></app-pop-up-header>

  <div class="comment">
    <span class="field-name">Acknowledgement has been saved.</span>
  </div>

  <app-pop-up-footer>
    <app-button [name]="'Go to workflows'" [type]="'primary'" (btnClick)="BacktoManageWorkflow()"></app-button>
  </app-pop-up-footer>
</app-pop-up>



<app-pop-up *ngIf="showComments">
  <app-pop-up-header [textTransformNone]="true" [headerName]="'Comments(' + comments.length + ')'" (close)="showComments = !showComments"></app-pop-up-header>
  <div class="commentContainer">
    <div *ngIf="comments && comments.length" >
      <div class="commentList" *ngFor="let commentList of comments; let i = index">
        <span class="username">{{commentList.userName}}</span>
        <span class="updatedOn"> - {{commentList.updatedDate |date : 'medium'}}</span>
        <div class="commentStyle">{{commentList.comment}}</div>
        </div>
    </div>
    </div>
    <app-pop-up-footer>
      <app-button [name]="'Close'" [type]="'primary'" (btnClick)="showComments = !showComments"></app-button>
    </app-pop-up-footer>
</app-pop-up>

<app-pop-up *ngIf="showConsentedForms" class="consent-forms">
  <app-pop-up-header [textTransformNone]="true" [headerName]="'CP/QP Consent'" (close)="showConsentedForms = !showConsentedForms">
  </app-pop-up-header>
  <app-alert [alert]="consentAlert"></app-alert>
  <div class="consent-table">
    <app-table-grid
      [headers]="consentedFormHeader"
      [data]="consentedFormsData"
      [showCount]="true"
      (onRowSelect)="onRowSelect($event)"
      (onDownload)="onDownload($event)"
    ></app-table-grid>
  </div>
  <app-pop-up-footer>
    <app-button [name]="'Close'" [type]="'primary'" (btnClick)="showConsentedForms = !showConsentedForms"></app-button>
  </app-pop-up-footer>
</app-pop-up>

<app-consent-to-publish
  *ngIf="viewConsentForm"
  [usingAsElement]="true"
  [yearCode]="yearCode"
  [assingId]="selectedConsent.loginID"
  [isNonConsentedCP]="selectedConsent.isConsentPublished === '1'"
  [workflowID]="selectedConsent.wfid"
  (onClose)="viewConsentForm = !viewConsentForm">
</app-consent-to-publish>





